import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/i18n";

export default function NotFoundPage() {
  const { t } = useLanguage();
  return (
    <div data-testid="not-found-page" className="font-body bg-[#F6F8FD] text-[#0F2645] min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20 flex items-center justify-center px-6">
        <div className="text-center py-24">
          <p className="font-heading text-7xl font-black text-[#3A5CC8]">404</p>
          <h1 className="mt-4 font-heading text-3xl font-bold tracking-tight text-[#0F2645]">{t("Page introuvable")}</h1>
          <p className="mt-3 text-base text-[#5C6A87]">{t("Cette page n'existe pas ou a été déplacée.")}</p>
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#3A5CC8] px-8 py-4 text-base font-semibold text-white hover:bg-[#3A5CC8] transition-colors duration-200"
          >
            <ArrowLeft className="w-5 h-5" /> {t("Retour à l'accueil")}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
